import { composeValidators } from '@reliance/forms-js/lib/validation';
import React, { ChangeEventHandler } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import Row from 'react-bootstrap/Row';
import { Field } from 'react-final-form';

type TextAreaProps = {
  name: string
  rows: number
  label?: string|JSX.Element
  id?: string
  placeholder?: string
  validationRules?: any[]
  helperText?: string
  onChange?: ChangeEventHandler
}

type InlineTextAreaProps = TextAreaProps & {
  labelCols: number
}

export const TextArea: React.FC<TextAreaProps> = (props) =>
  <Field
    name={props.name}
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) => (
      <FormGroup>
        {props.label &&
          <label>{props.label}</label>
        }
        <textarea
          id={props.id}
          rows={props.rows}
          placeholder={props.placeholder}
          className={`form-control full-width ${meta.touched && meta.error ? 'has-error' : ''}`}
          disabled={meta.submitting}
          {...input}
          onChange={(e) => {
            input.onChange(e);
            props.onChange?.(e);
          }} />
        {((meta.error && meta.touched) || props.helperText) &&
          <span className="help-block has-error">{meta.error && meta.touched ? meta.error : props.helperText}</span>
        }
      </FormGroup>
    )}
  </Field>

export const InlineTextArea: React.FC<InlineTextAreaProps> = (props) =>
  <Field
    name={props.name}
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) => (
      <Form.Group as={Row}>
        <Form.Label column sm={props.labelCols}>{props.label}</Form.Label>
        <Col>
          <textarea
            id={props.id}
            rows={props.rows}
            placeholder={props.placeholder}
            className={`form-control full-width ${meta.touched && meta.error ? 'has-error' : ''}`}
            disabled={meta.submitting}
            {...input}
            onChange={(e) => {
              input.onChange(e);
              props.onChange?.(e);
            }} />
          {((meta.error && meta.touched) || props.helperText) &&
            <span className="help-block has-error">{meta.error && meta.touched ? meta.error : props.helperText}</span>
          }
        </Col>
      </Form.Group>
    )}
  </Field>